import { IntlShape } from 'react-intl';

import { facet, getTextWithSoftHyphens } from '@app/components';
import { LocationDto } from '@app/hooks';

import { MappedFacetValue, UnmappedFacetValue } from '../constants';
import { getLocationOptions } from './getLocationOptions';
import { getLanguageOptions } from './getLanguageOptions';
import { getStatusOptions } from './getStatusOptions';

interface FacetMappingValueProps {
  facetName: string;
  values: UnmappedFacetValue[];
  locations?: LocationDto[];
  $t: IntlShape['$t'];
}

const getDefaultFacetValue = (values: UnmappedFacetValue[]) =>
  values.map(({ id, totalRecords }) => ({
    label: getTextWithSoftHyphens(id),
    value: id,
    id,
    count: totalRecords,
  }));

export const getMappedFacetValues = ({
  $t,
  facetName,
  values,
  locations,
}: FacetMappingValueProps): MappedFacetValue[] => {
  switch (facetName) {
    case facet.status:
      return getStatusOptions($t, values);
    case facet.language:
      return getLanguageOptions({ $t, languagesValues: values });
    case facet.location:
      return getLocationOptions({ locations, values });
    default:
      return getDefaultFacetValue(values);
  }
};
